/**
 * Права панель (layout.md, розд. 1): на стартовому екрані — «Сьогодні», 320 px поруч від
 * 1280 px, нижче — поверх. Стан «відкрито / згорнуто» тримає оболонка (today-context.ts).
 */
import { TodayPanel } from '../features/today/TodayPanel.tsx';
import { today as t } from '../i18n/uk/today.ts';

export const ASIDE_ID = 'app-aside';

export function TodayAside({ onCollapse }: { onCollapse: () => void }) {
  return (
    <aside id={ASIDE_ID} className="aside" aria-label={t.todayTitle} tabIndex={-1}>
      <TodayPanel onCollapse={onCollapse} />
    </aside>
  );
}
